/**
 * @fileoverview Input/output schemas for the run-refine-full-v2 composite agent.
 *
 * This composite agent orchestrates a two-step pipeline:
 * 1. refine-synthesizer: Creates an editorial brief from ALL findings/weaknesses
 * 2. draft-refiner-v2: Refines the chapter based on the editorial brief
 *
 * Reuses the same schemas as run-refine-v2 since the structure is identical.
 * The difference is in how the agent is invoked (all items vs selected items).
 */

// Re-export all schemas from run-refine-v2 since they're identical
export {
  FindingSchema,
  WeaknessSchema,
  StrengthSchema,
  HookInputSchema,
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
  type HookInput,
} from '@/ai/agents/composites/run-refine-v2/schema';
